package uz.ferro.erp.feature.text.ui

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.span
import uz.ferro.erp.feature.text.model.TextItem
import uz.ferro.erp.feature.text.model.TextStyle
import web.cssom.FontStyle
import web.cssom.FontWeight

external interface DocTextItemProps : Props {
    var textItem: TextItem
}

val DocTextItemView = FC<DocTextItemProps> { props ->
    val item = props.textItem
    span {
        css {
            if (item.style == TextStyle.BOLD || item.style == TextStyle.BOLD_ITALIC) {
                fontWeight = FontWeight.bold
            }

            if (item.style == TextStyle.ITALIC || item.style == TextStyle.BOLD_ITALIC) {
                fontStyle = FontStyle.italic
            }
        }

        +item.text.orEmpty()
    }
}